import React, { ComponentProps } from 'react';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { Fieldset, Form, Input, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Hint } from '../../../_lib/components/Hint';

type FormApplicationNotificationsEditProps = {
  form: SonForm<TextParam<'emailAddress1'> | TextParam<'emailAddress2'> | TextParam<'emailAddress3'>>;
  refresh: () => void;
};

function FormApplicationNotificationsEdit({ form }: FormApplicationNotificationsEditProps) {
  const { t } = useSonTranslation('FormApplicationNotifications');
  const { refresh } = useViewContext();

  const { formProps, params, fetchState } = useForm({ form, onSuccess: refresh });

  const emailAddress1 = params.getByName('emailAddress1');
  const emailAddress2 = params.getByName('emailAddress2');
  const emailAddress3 = params.getByName('emailAddress3');

  return (
    <div className="form-application-notifications__edit-container">
      <Form {...formProps}>
        <Fieldset legend={t('form.fieldsetLegend')}>
          <Row>
            <Hint message={t('form.emailHint')} />
          </Row>
          <Row>
            <Input label={t('form.emailAddress1Label')} param={emailAddress1} />
          </Row>
          <Row>
            <Input label={t('form.emailAddress2Label')} param={emailAddress2} />
          </Row>
          <Row>
            <Input label={t('form.emailAddress3Label')} param={emailAddress3} />
          </Row>
          <SubmitButton
            buttonLabel={t('form.submitButtonLabel')}
            messageSuccess={t('phrases:changeSuccesfull')}
            messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
            messageFail={t('phrases:changesCouldNotBeSaved')}
            fetchState={fetchState}
          />
        </Fieldset>
      </Form>
    </div>
  );
}

export const FormApplicationNotificationsEditView = asFetchableView(FormApplicationNotificationsEdit);
export type FormApplicationNotificationsEditView = ComponentProps<typeof FormApplicationNotificationsEditView>;
